import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class Logic3x3matrix extends DesigntimeComponent {
    static staticName = "Logic: 3x3 matrix";
    static staticId = "logic3x3matrix";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {};

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 1 },
            parameter2: { key: "url:monthlySpending", value: 1 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $("<div class='logic3x3matrix'></div>");
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (eventParams.key == this.params.parameter1.key)
            this.params.parameter1.value = eventParams.value;
        else if (eventParams.key == this.params.parameter2.key)
            this.params.parameter2.value = eventParams.value;
        else
            return;

        this.resetAll();

        let total = 1;

        if (this.params.parameter1.value == 1 && this.params.parameter2.value == 1) {
            total = 1;
            this.eventBroker.fireValueChanged(this.id, "v_1_1", true);
        }
        if (this.params.parameter1.value == 1 && this.params.parameter2.value == 2) {
            total = 2;
            this.eventBroker.fireValueChanged(this.id, "v_1_2", true);
        }
        if (this.params.parameter1.value == 1 && this.params.parameter2.value == 3) {
            total = 3;
            this.eventBroker.fireValueChanged(this.id, "v_1_3", true);
        }

        if (this.params.parameter1.value == 2 && this.params.parameter2.value == 1) {
            total = 4;
            this.eventBroker.fireValueChanged(this.id, "v_2_1", true);
        }
        if (this.params.parameter1.value == 2 && this.params.parameter2.value == 2) {
            total = 5;
            this.eventBroker.fireValueChanged(this.id, "v_2_2", true);
        }
        if (this.params.parameter1.value == 2 && this.params.parameter2.value == 3) {
            total = 6;
            this.eventBroker.fireValueChanged(this.id, "v_2_3", true);
        }

        if (this.params.parameter1.value == 3 && this.params.parameter2.value == 1) {
            total = 7;
            this.eventBroker.fireValueChanged(this.id, "v_3_1", true);
        }
        if (this.params.parameter1.value == 3 && this.params.parameter2.value == 2) {
            total = 8;
            this.eventBroker.fireValueChanged(this.id, "v_3_2", true);
        }
        if (this.params.parameter1.value == 3 && this.params.parameter2.value == 3) {
            total = 9;
            this.eventBroker.fireValueChanged(this.id, "v_3_3", true);
        }

        this.eventBroker.fireValueChanged(this.id, "value", total);
    }

    resetAll() {
        this.eventBroker.fireValueChanged(this.id, "v_1_1", false);
        this.eventBroker.fireValueChanged(this.id, "v_1_2", false);
        this.eventBroker.fireValueChanged(this.id, "v_1_3", false);

        this.eventBroker.fireValueChanged(this.id, "v_2_1", false);
        this.eventBroker.fireValueChanged(this.id, "v_2_2", false);
        this.eventBroker.fireValueChanged(this.id, "v_2_3", false);

        this.eventBroker.fireValueChanged(this.id, "v_3_1", false);
        this.eventBroker.fireValueChanged(this.id, "v_3_2", false);
        this.eventBroker.fireValueChanged(this.id, "v_3_3", false);
    }

    output = [
        { name: "value", type: "number" },
        { name: "v_1_1", type: "bool" },
        { name: "v_1_2", type: "bool" },
        { name: "v_1_3", type: "bool" },
        { name: "v_2_1", type: "bool" },
        { name: "v_2_2", type: "bool" },
        { name: "v_2_3", type: "bool" },
        { name: "v_3_1", type: "bool" },
        { name: "v_3_2", type: "bool" },
        { name: "v_3_3", type: "bool" },
    ];
}

export { Logic3x3matrix }
